export default __webpack_public_path__ + "static/media/Page11.fa5710f7.txt";